/*
 * @Descripttion:
 * @version: 购物车接口
 * @Author: limin
 * @Date: 2021-03-23 17:18:02
 * @LastEditors: limin
 * @LastEditTime: 2021-03-25 21:01:32
 */
import request from '../request'
const path = 'ddh.carlife.mall.shop.car'
export default {
  /**
   * 查询购物车列表
   */
  get(data={}) {
    data.method = `${path}.list`
    return request(data)
  },
  /**
   * 加入购物车
   * @param {} data 商品信息
   */
  add(data){
    data.method = `${path}.add`
    return request(data)
  },
  /**
   * 修改购物车商品数量
   * @param {} id 商品id
   * @param {} goodsNum 商品数量
   */
  edit(id,goodsNum){
    let data = {
      id,
      goodsNum,
      method: `${path}.update`
    }
    return request(data)
  },
   /**
   * 删除购物车商品
   * @param {} address
   */
  remove(id){
    let data = {
      id,
      method: `${path}.delete`
    }
    return request(data);
  }
}
